import { render, staticRenderFns } from "./TreatmentSketchServiceRow.vue?vue&type=template&id=82994556&"
import script from "./TreatmentSketchServiceRow.vue?vue&type=script&lang=js&"
export * from "./TreatmentSketchServiceRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports